import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchspecializations, fetchDoctors } from '../../Services/apiService';
import Button from '../Button';
import DoctorSlider from './slider';
import '../../Styles/home.css';

const Home = () => {
  const [specializations, setSpecializations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [doctors, setDoctors] = useState([]);

  // Load specializations
  useEffect(() => {
    const loadSpecializations = async () => {
      try {
        setLoading(true);
        const data = await fetchspecializations();
        setSpecializations(data || []);
      } catch (err) {
        console.error('Error fetching specializations:', err);
        setError('Failed to load specializations.');
      } finally {
        setLoading(false);
      }
    };
    loadSpecializations();
  }, []);

  // FETCH ALL DOCTORS USING useEffect async await
  useEffect(() => {
    const loadDoctors = async () => {
      const data = await fetchDoctors();
      setDoctors(data);
    };
    loadDoctors();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="error">{error}</p>;

  return (
    <div className="home">
      <h1 className="scroll-text my-1 transition-item-float">
        <p className="text-slate-950 font-bold">ডাক্তার ও মেডিক্যাল সার্ভিস সংক্রান্ত তথ্যাবলি</p>
      </h1>
      <DoctorSlider doctors={doctors} />
      {specializations.length > 0 ? (
        <div className="my-9 pl-3 text-center">
          {specializations.map((spec) => (
            <Link key={spec.id} to={`/districts?specialization=${spec.id}`}>
              <Button
                type="button"
                label={spec.name}
                className={`transition-item-float px-4 py-2 mx-2 my-2 rounded-lg transition-colors duration-200 ${
                  'text-blue-700 hover:text-white bg-transparent border border-blue-500 hover:border-transparent hover:bg-indigo1 hover:from-blue-600 hover:to-blue-500 font-semibold'
                }`}
              />
            </Link>
          ))}

        </div>
      ) : (
        <p>No specializations found.</p>
      )}
    </div>
  );
};

export default Home;
